module.exports = __webpack_public_path__ + "static/media/noun_deal_1156458.3cfdf32a.svg";